import soundbord from "./soundbord"

export default soundbord